import { render, staticRenderFns } from "./school-select.vue?vue&type=template&id=6cbbd572"
import script from "./school-select.vue?vue&type=script&lang=js"
export * from "./school-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../voice-2025/node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports